export const BASE_URL = process.env.REACT_APP_API_URL;

export const urlBase = process.env.REACT_APP_BASE_URL;


export async function request(path, options = {}) {
  const base = String(BASE_URL).replace(/\/+$/, '');
  const url = `${base}${path}`;
  const headers = { ...(options.headers || {}) };
  if (options.body != null && !('Content-Type' in headers)) {
    headers['Content-Type'] = 'application/json';
  }
  try {
    const method = options.method || 'GET';
    const hasAuth = Object.prototype.hasOwnProperty.call(headers, 'Authorization');
    const contentType = headers['Content-Type'];
    const bodyInfo = typeof options.body === 'string' ? `${options.body.length}b` : (options.body ? 'object' : null);
    // console.log('[api.request]', { url, method, hasAuth, contentType, body: bodyInfo });
  } catch { }
  const res = await fetch(url, { ...options, headers });
  if (!res.ok) {
    const text = await res.json();
    throw new Error(text.error || text.Error || text.message || text.Message || text || `HTTP ${res.status}`);

  }

  const contentType = res.headers.get('content-type') || '';
  return contentType.includes('application/json') ? res.json() : res.text();
}






export async function loginApi({ email, password, tenantId }) {
  return request('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password, client: 'web', tenantId }),
  });
}

// export { BASE_URL };

export async function fetchTenantsApi() {
  const data = await request('/tenant', { method: 'GET' });
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.value)) return data.value;
  if (Array.isArray(data?.items)) return data.items;
  return [];
}

// Companies
export async function fetchCompaniesApi({ token } = {}) {
  const data = await request('/Company', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((c) => ({ id: c.id ?? c.Id ?? c.code ?? c.Code, name: c.name ?? c.Name ?? c.descripcion ?? '' }));
}

//Districts
export async function fetchDistrictsApi({ token } = {}) {
  const data = await request('/district', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((d) => ({ id: d.id ?? d.Id ?? d.code ?? d.Code ?? d.value, name: d.name ?? d.Name ?? d.descripcion ?? String(d.id ?? '') }));
}
//Yards
export async function createYardApi({ tenantId, districtId, name, address, latitude, longitude, token }) {
  return request('/Yard', {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      tenantId: Number(tenantId),
      districtId: String(districtId),
      name,
      address,
      latitude: Number(latitude),
      longitude: Number(longitude),
    }),
  });
}

export async function fetchYardsApi({ token } = {}) {
  const data = await request('/Yard', {
    method: 'GET',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((y) => ({
    id: y.id ?? y.Id,
    nombre: y.name ?? y.Nombre,
    direccion: y.address ?? y.Direccion,
    lat: y.latitude ?? y.Latitude,
    lng: y.longitude ?? y.Longitude,
    distrito: y.district?.name ?? y.District?.name ?? '',
    districtId: y.district?.id ?? y.District?.id ?? null,
  }));
}

export async function GetYardById({ yardId, token }) {
  const data = await request(`/Yard/${yardId}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  return data.value;
}



// Emergency Contacts APIs
export async function fetchContactEmergenciesApi({ token } = {}) {
  const data = await request('/ContactEmergency', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((c) => ({ id: c.id ?? c.Id, name: c.nameContact ?? c.Nombre ?? c.contacto, phone: c.phone ?? c.Phone ?? c.telefono }));
}

export async function createContactEmergencyApi({ nameContact, phone, token }) {
  return request('/ContactEmergency', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ nameContact, phone }),
  });
}

export async function updateContactEmergencyApi({ id, nameContact, phone, token }) {
  return request(`/ContactEmergency/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ nameContact, phone }),
  });
}

export async function deleteContactEmergencyApi({ id, token }) {
  return request(`/ContactEmergency/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}
// Point Control APIs
export async function fetchPointControlsByYardApi(yardId, { token } = {}) {
  const data = await request(`/PointControl/yard/${encodeURIComponent(yardId)}`, {
    method: 'GET',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((p) => ({
    id: p.id ?? p.Id,
    yardId: p.yardId ?? p.YardId,
    name: p.name ?? p.Name,
    location: p.location ?? p.Location,
    latitude: p.latitude ?? p.Latitude,
    longitude: p.longitude ?? p.Longitude,
    geozoneRadio: p.geozoneRadio ?? p.GeozoneRadio ?? 10,
    order: p.order ?? p.Order ?? 0,
  }));
}

export async function createPointControlApi({ yardId, name, location, latitude, longitude, geozoneRadio, token }) {
  return request('/PointControl', {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ yardId, name, location, latitude, longitude, geozoneRadio }),
  });
}

export async function updatePointControlApi({ id, yardId, name, location, latitude, longitude, geozoneRadio, order, token }) {
  return request(`/PointControl/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      yardId: String(yardId),
      name,
      location,
      latitude: Number(latitude),
      longitude: Number(longitude),
      geozoneRadio: Number(geozoneRadio),
      order: Number(order),
    }),
  });
}

export async function createPointControlBatchApi({ items, token }) {
  // items: [{ yardId, name, location, latitude, longitude, geozoneRadio }]
  return request('/PointControl/batch', {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(items || []),
  });
}

export async function deletePointControlApi({ id, token }) {
  const cleanId = encodeURIComponent(String(id).replace(/[{}]/g, '').trim());
  return request(`/PointControl/${cleanId}`, {
    method: 'DELETE',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}

//yard
export async function deleteYardApi({ id, token }) {
  return request(`/Yard/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}

export async function updateYardApi({ id, districtId, name, address, latitude, longitude, token }) {
  return request(`/Yard?Id=${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      districtId: String(districtId),
      name,
      address,
      latitude: Number(latitude),
      longitude: Number(longitude),
    }),
  });
}


// Assignments (Asignaciones)
export async function createAssignmentApi({ token, dto }) {
  return request('/Assignmets', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(dto),
  });
}

export async function fetchAssignmentsByYardApi({ yardId, token }) {
  const data = await request(`/Assignmets/yard/${encodeURIComponent(String(yardId))}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map(a => ({
    id: a.id ?? a.Id,
    observation: a.observation ?? '',
    initDatePlanning: a.initDatePlanning ?? a.InitDatePlanning,
    endDatePlanning: a.endDatePlanning ?? a.EndDatePlanning,
    initHourShift: a.initHourShift ?? a.InitHourShift,
    endHourShift: a.endHourShift ?? a.EndHourShift,
    state: a.state ?? a.State,
  }));
}

export async function updateAssignmentApi({ id, token, dto }) {
  return request(`/Assignmets/${encodeURIComponent(String(id))}`, {
    method: 'PUT',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(dto),
  });
}
export async function deleteAssignmentApi({ id, token }) {
  return request(`/Assignmets/${encodeURIComponent(String(id))}`, {
    method: 'DELETE',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}
// Automatic Assignment
export async function createAutomaticAssignmentApi({
  startDate,
  endDate,
  yardId,
  userId,
  startTime,
  endTime,
  intervalTime,
  token
}) {
  const response = await request('/Assignmets/automatic', {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      startDate,
      endDate,
      yardId,
      userId,
      startTime,
      endTime,
      intervalTime
    }),
  });
  return response;
}
//Manual Assignment
export async function assignManualApi({ token, dto }) {
  const r = await fetch('/Assignmets/manual', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(dto),
  });
  return r.json();
}


//USERS
export async function createUserApi({ token, dto }) {
  return request('/Users/users', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ dto }),
  });
}

export async function fetchUsersApi({ token } = {}) {
  const data = await request('/Users', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  console.log("vigilantes listado")
  console.log(data);
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  const mapped = arr.map((u) => ({
    id: u.id ?? u.Id,
    empresaId: u.company?.id ?? u.Company?.id ?? u.companyId ?? u.CompanyId ?? u.empresaId,
    nombres: u.name ?? u.Nombre ?? u.nombres,
    apellidos: u.lastName ?? u.Apellido ?? u.apellidos,
    identificacion: u.identification ?? u.Identification ?? u.dni ?? u.DNI,
    email: u.email ?? u.Email,
    accesoWeb: Boolean(u.accessWeb ?? u.AccessWeb ?? u.accessweb ?? u.accesoWeb),
    accesoMovil: Boolean(u.accessAppMovil ?? u.AccessAppMovil ?? u.accessappmovil ?? u.accesoMovil),
    mustFollowOrder: Boolean(u.mustFollowOrder ?? u.MustFollowOrder ?? u.mustfolloworder ?? u.debeSeguirOrden ?? false),
    isActive: Boolean(u.isActive ?? u.state ?? u.State ?? u.active),
    companyName: u.company?.name ?? u.Company?.name ?? u.companyName,
    role: u.role != null ? Number(u.role) : (u.Role != null ? Number(u.Role) : undefined),
  }));
  mapped.sort((a, b) => {
    const ag = a.isActive ? 0 : 1;
    const bg = b.isActive ? 0 : 1;
    if (ag !== bg) return ag - bg;
    return String(a.apellidos || '').localeCompare(String(b.apellidos || ''), 'es', { sensitivity: 'base' });
  });
  return mapped;
}

export async function fetchOnlyVigilantApi({ token } = {}) {
  const data = await request('/Users/OnlyVigilant', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  // console.log("vigilantes listado")
  // console.log(data);
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  const mapped = arr.map((u) => ({
    id: u.id ?? u.Id,
    empresaId: u.company?.id ?? u.Company?.id ?? u.companyId ?? u.CompanyId ?? u.empresaId,
    nombres: u.name ?? u.Nombre ?? u.nombres,
    apellidos: u.lastName ?? u.Apellido ?? u.apellidos,
    identificacion: u.identification ?? u.Identification ?? u.dni ?? u.DNI,
    email: u.email ?? u.Email,
    accesoWeb: Boolean(u.accessWeb ?? u.AccessWeb ?? u.accessweb ?? u.accesoWeb),
    accesoMovil: Boolean(u.accessAppMovil ?? u.AccessAppMovil ?? u.accessappmovil ?? u.accesoMovil),
    mustFollowOrder: Boolean(u.mustFollowOrder ?? u.MustFollowOrder ?? u.mustfolloworder ?? u.debeSeguirOrden ?? false),
    isActive: Boolean(u.isActive ?? u.state ?? u.State ?? u.active),
    companyName: u.company?.name ?? u.Company?.name ?? u.companyName,
    role: u.role != null ? Number(u.role) : (u.Role != null ? Number(u.Role) : undefined),
  }));
  mapped.sort((a, b) => {
    const ag = a.isActive ? 0 : 1;
    const bg = b.isActive ? 0 : 1;
    if (ag !== bg) return ag - bg;
    return String(a.apellidos || '').localeCompare(String(b.apellidos || ''), 'es', { sensitivity: 'base' });
  });
  return mapped;
}

export async function fetchUpdateUser({ id, name, lastName, identification, email, role, accessWeb, accessAppMovil, mustFollowOrder, password, companyId, token }) {
  return request(`/Users/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      name,
      lastName,
      identification,
      email,
      role,
      accessWeb,
      accessAppMovil,
      mustFollowOrder,
      password,
      companyId

    })
  });


}
export async function toggleUserActiveApi({ id, state, token }) {
  const qs = `?state=${encodeURIComponent(String(state))}`;
  return request(`/Users/${encodeURIComponent(id)}/UpdateState${qs}`, {
    method: 'PATCH',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}

export async function deleteUserApi({ id, token }) {
  return request(`/Users/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}




// PerimeterYards
export async function fetchPerimeterYardsApi({ token } = {}) {
  const data = await request('/PerimeterYard', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((p) => ({
    id: p.id ?? p.Id,
    order: p.order ?? p.order ?? '',
    yardId: p.yardId ?? p.YardId,
    yardName: p.yard?.name ?? p.Yard?.name ?? p.yardName ?? '',
  }));
}

export async function createPerimeterYardApi({ name, description, yardId, token }) {
  return request('/PerimeterYard', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      name,
      description,
      yardId,
    }),
  });
}

export async function updatePerimeterYardApi({ id, order, longitude, latitude, token }) {
  return request('/PerimeterYard', {
    method: 'PUT',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      id,
      order,
      longitude,
      latitude
    }),
  });
}

export async function deletePerimeterYardApi({ id, token }) {
  return request(`/PerimeterYard/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}
export async function GetPerimeterYard({ yardId, token }) {
  const data = await request(`/PerimeterYard/${yardId}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  return data.value;
}

//List para crear perimetros del patio
export async function createPerimeterYardListApi({ items, token }) {
  const payload = Array.isArray(items) ? items : [];
  return request('/PerimeterYard/PerimeterYardList', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(payload),
  });
}

//Rounds
export async function fetchRoundsApi({ token } = {}) {
  const data = await request('/Rounds', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((r) => ({
    id: r.id ?? r.Id,
    name: r.name ?? r.Nombre,
    description: r.description ?? r.Description ?? '',
    roundDate: r.roundDate ?? r.RoundDate,
    status: r.status ?? r.Status,
    userId: r.userId ?? r.UserId,
    userName: r.user?.name ?? r.User?.name ?? r.userName ?? '',
  }));
}

export async function GetRoundById({ id, token }) {
  const data = await request(`/Rounds/${encodeURIComponent(id)}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  return data.value;
}
export async function GetAllRoundsForDare({ userId, startDate, endDate, token }) {
  const params = new URLSearchParams();
  if (userId) params.set('userId', userId);
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  const query = params.toString();
  const url = query ? `/Rounds/forVigilantAndDate?${query}` : '/Rounds/forVigilantAndDate';

  const data = await request(url, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((r) => ({
    id: r.id ?? r.Id ?? r.roundId ?? r.RoundId ?? null,
    name: r.name ?? r.Name ?? '',
    description: r.description ?? r.Description ?? '',
    status: r.status ?? r.Status ?? '',
    state: r.state ?? r.State ?? (typeof r.status === 'number' ? r.status : null),
    userId: r.userId ?? r.UserId ?? r.user?.id ?? r.User?.id ?? null,
    userName: r.user?.name ?? r.User?.name ?? r.userName ?? '',
    initDatePlanning: r.initDatePlanning ?? r.InitDatePlanning ?? null,
    endDatePlanning: r.endDatePlanning ?? r.EndDatePlanning ?? null,
    yardName: r.yardName ?? r.YardName ?? '',
    roundDate: r.roundDate ?? r.RoundDate ?? null,
  }));
}
export async function GetRoundsByAssignments({ id, token }) {
  const data = await request(`/Rounds/assignment/${encodeURIComponent(id)}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  return data.value;
}

export async function createRoundApi({ userId, assignmentsId, initDatePlanning, endDatePlanning, token }) {
  return request('/Rounds', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      userId,
      assignmentsId,
      initDatePlanning,
      endDatePlanning,
    }),
  });
}

export async function createRoundsBulkApi({ yardId, rows, token }) {
  return request(`/Rounds/bulk?yardId=${encodeURIComponent(yardId)}`, {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), 'Content-Type': 'application/json', },
    body: JSON.stringify(rows)
  });

}

export async function updateRoundApi({ id, userId, initDatePlanning, endDatePlanning, state, token }) {
  return request(`/Rounds/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      userId,
      initDatePlanning,
      endDatePlanning,
      state
    }),
  });
}

export async function deleteRoundApi({ id, token }) {
  return request(`/Rounds/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}

// Bulk assignment of rounds to a user
export async function assignRoundsBulkApi({ userId, roundIds, token }) {
  const payload = {
    userId,
    // Backend expects an array of objects with { id }
    roundIds: (Array.isArray(roundIds) ? roundIds : [])
      .filter((x) => x != null)
      .map((x) => (typeof x === 'object' && x.id ? { id: x.id } : { id: x })),
  };
  console.log("api masivo")
  console.log(payload)
  return request('/Rounds/assign-bulk', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(payload),
  });
}



// Point Controls
export async function fetchPointControlsApi({ token } = {}) {
  const data = await request('/PointControl', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((p) => ({
    id: p.id ?? p.Id,
    name: p.name ?? p.Nombre,
    location: p.location ?? p.Location,
    latitude: p.latitude ?? p.Latitude,
    longitude: p.longitude ?? p.Longitude,
    geozoneRadio: p.geozoneRadio ?? p.GeozoneRadio ?? 10,
    yardId: p.yardId ?? p.YardId,
    yardName: p.yard?.name ?? p.Yard?.name ?? p.yardName ?? '',
  }));
}

export async function createPointControlApiFull({ name, location, latitude, longitude, geozoneRadio, yardId, token }) {
  return request('/PointControl', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      name,
      location,
      latitude,
      longitude,
      geozoneRadio,
      yardId,
    }),
  });
}

export async function updatePointControlApiFull({ id, name, location, latitude, longitude, geozoneRadio, yardId, token }) {
  return request(`/PointControl/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      name,
      location,
      latitude,
      longitude,
      geozoneRadio,
      yardId,
    }),
  });
}

export async function deletePointControlApiFull({ id, token }) {
  return request(`/PointControl/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}

// Point Control Visited
export async function fetchPointControlVisitedsApi({ token } = {}) {
  const data = await request('/PointControlVisited', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((p) => ({
    id: p.id ?? p.Id,
    pointControlId: p.pointControlId ?? p.PointControlId,
    pointControlName: p.pointControl?.name ?? p.PointControl?.name ?? p.pointControlName ?? '',
    visitDate: p.visitDate ?? p.VisitDate,
    userId: p.userId ?? p.UserId,
    userName: p.user?.name ?? p.User?.name ?? p.userName ?? '',
    status: p.status ?? p.Status,
  }));
}

export async function createPointControlVisitedApi({ pointControlId, visitDate, userId, status, token }) {
  return request('/PointControlVisited', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      pointControlId,
      visitDate,
      userId,
      status,
    }),
  });
}

export async function updatePointControlVisitedApi({ id, pointControlId, visitDate, userId, status, token }) {
  // NOTA: No se encontró un endpoint PUT/UPDATE explícito para PointControlVisiteds en el backend
  // Por lo tanto, este método no se puede implementar actualmente
  throw new Error('El endpoint de actualización para PointControlVisiteds no está disponible en el backend');
}

export async function deletePointControlVisitedApi({ id, token }) {
  return request(`/PointControlVisited/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}

// Incidents with Evidence
export async function fetchIncidentsWithEvidenceApi({ token } = {}) {
  const data = await request('/Incidents', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr;
}

export async function createIncidentWithEvidenceApi({ incidentData, token }) {
  return request('/Incidents', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(incidentData),
  });
}

export async function updateIncidentWithEvidenceApi({ id, incidentData, token }) {
  return request(`/Incidents/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(incidentData),
  });

}

export async function deleteIncidentWithEvidenceApi({ id, token }) {
  return request(`/Incidents/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}

export async function uploadIncidentEvidenceApi({ incidentId, evidenceFile, token }) {
  const formData = new FormData();
  formData.append('evidence', evidenceFile);

  return request(`/Incidents/${encodeURIComponent(incidentId)}/evidence`, {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {})
      // No se incluye Content-Type para que el navegador lo establezca con el boundary correcto
    },
    body: formData,
  });
}

// Tracking Location
export async function fetchTrackingLocationsApi({ token } = {}) {
  const data = await request('/TrackingLocation', {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((t) => ({
    id: t.id ?? t.Id,
    userId: t.userId ?? t.UserId,
    userName: t.user?.name ?? t.User?.name ?? t.userName ?? '',
    latitude: t.latitude ?? t.Latitude,
    longitude: t.longitude ?? t.Longitude,
    locationDate: t.locationDate ?? t.LocationDate,
    accuracy: t.accuracy ?? t.Accuracy ?? 0,
  }));
}

export async function createTrackingLocationApi({ userId, latitude, longitude, locationDate, accuracy, token }) {
  return request('/TrackingLocation', {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      userId,
      latitude,
      longitude,
      locationDate,
      accuracy,
    }),
  });
}

export async function updateTrackingLocationApi({ id, userId, latitude, longitude, locationDate, accuracy, token }) {
  // NOTA: No se encontró un endpoint PUT/UPDATE explícito para TrackingLocation en el backend
  // Por lo tanto, este método no se puede implementar actualmente
  throw new Error('El endpoint de actualización para TrackingLocation no está disponible en el backend');
}

export async function deleteTrackingLocationApi({ id, token }) {
  return request(`/TrackingLocation/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
}
//Incidents
export const ListarIncidenciasPorRonda = async ({ roundId, token }) => {
  console.log(token)
  const data = await request(`/Incidents/ListIncidentsByRound/${roundId.trim()}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  console.log("DATA DE API")
  console.log(data)
  return data.value;
}

export const ListarEvidenciasPorIncidencia = async ({ incidenciaId, token }) => {
  const data = await request(`/Incidents/ViewEvidenceByIncident/${incidenciaId}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  // return Array.isArray(data?.value) ? data.value : [];
  return data.value;
}

export const ListarIncidenciasPorPatioYFecha = async ({ yardId, startDate, endDate, token }) => {
  const data = await request(`/Incidents/ListForIncidentYardAndDate?YardId=${yardId}&startDate=${startDate}&endDate=${endDate}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  // console.log("FETCH")
  console.log(data.value)
  const arr = Array.isArray(data)
    ? data
    : (Array.isArray(data?.value) ? data.value : (Array.isArray(data?.items) ? data.items : []));
  return arr.map((i) => ({
    id: i.id,
    description: i.description,
    typeIncident: i.typeIncident,
    levelIncident: i.levelIncident,
    isEmergency: i.isEmergency,
    creationDate: i.creationDate,
    state: i.state,
    latitude: i.latitude,
    longitude: i.longitude,
    userName: i.userName,
    userLastName: i.userLastName,
    yardId: i.yardId,
    incidentResult: i.incidentResult
  }));
}
//Tracking 
export async function GetTrackingByRound({ roundId, token }) {
  const data = await request(`/TrackingLocation/${roundId}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  // const result= data.value.sort((a,b)=>localeCompare(a.))
  return data.value
}

//Reportes 
export const ListarAsignaciones = async ({ startDate, endDate, userId, yardId, token }) => {
  // construye el query solo con lo que tengas
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate);   // YYYY-MM-DD
  if (endDate) params.set('endDate', endDate);
  if (userId) params.set('userId', userId);
  if (yardId) params.set('yardId', yardId);

  const data = await request(`/reports/assignments?${params.toString()}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });

  // ← AQUÍ devolvemos el arreglo, NO un booleano
  return data.value;
}

export const ListarRondasReport = async ({ startDate, endDate, userId, assignmentId, token }) => {
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  if (userId) params.set('userId', userId);
  if (assignmentId) params.set('assignmentId', assignmentId);

  const data = await request(`/reports/assignments/rounds?${params}`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  console.log(data.value)
  return Array.isArray(data?.value) ? data.value : [];
};

//Status de cada punto de control
export const ListarPuntosControlResumen = async ({ roundId, token }) => {
  const data = await request(`/Rounds/${roundId}/points/status`, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  // return Array.isArray(data?.value) ? data.value : [];
  return data.items;
}

//Crear rondas masivas
export const CrearRondasMasivas = async ({ startDate, endDate, yardId, userId, startTime, endTime, intervalTime, token }) => {
  const data = await request(`/Assignmets/automatic`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      startDate,
      endDate,
      yardId,
      userId,
      startTime,
      endTime,
      intervalTime: Number(intervalTime),           // ✅ número
    }),
  });
  // return Array.isArray(data?.value) ? data.value : [];
  return data.value;
}


